import axios from 'axios';
import { DefaultFishGroupGraph } from 'views/planning-prognosis/features/view-fish-group/types/default-fish-group-graph.type';

// GET
// /ewosapi/v1/planandprognosis/fishgroup/{fishGroupId}/snapshot/{snapshotId}/data
export const getFishGroupSnapshot = async (
  fishGroupId: string,
  snapshotId: number,
  name: string
): Promise<{ name: string; graph: DefaultFishGroupGraph }> => {
  const res = await axios.get<DefaultFishGroupGraph>(
    `/ewosapi/v1/planandprognosis/fishgroup/${fishGroupId}/snapshot/${snapshotId}/data `
  );
  return { name: name, graph: res.data };
};
